var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-busy-skeleton" },
    _vm._l(_vm.rows, function(r) {
      return _c(
        "div",
        { key: "row-" + r, staticClass: "skeleton-row" },
        _vm._l(_vm.normalizedFields, function(field, idx) {
          return _c(
            "div",
            {
              key: "col-" + idx,
              class: ["skeleton-col", field.class],
              style: _vm.getColStyle(field)
            },
            [
              _c("b-skeleton", {
                staticClass: "m-0",
                attrs: { width: _vm.getSkeletonWidth(field, r) }
              })
            ],
            1
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49546707", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49546707","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/TablesSkeleton.vue
// module id = null
// module chunks = 